<template>
  <!-- Canvas List -->
  <v-row v-if="canvasList.length > 0">
    <v-col
      v-for="canvas in canvasList"
      :key="canvas.id"
      cols="12"
      md="6"
      sm="12"
      xl="4"
    >
      <v-card>
        <div style="text-align: center"></div>
        <v-img sm="10" :src="canvas.cover"> </v-img>
        <div class="d-flex flex-row" style="line-height: 36px">
          <div class="ml-2 my-3 mr-auto p-2">
            {{ canvas.createdTime }}
          </div>
          <div></div>
          <div class="ml-2 my-3 p-2">
            <v-btn block color="primary">插入到Slides</v-btn>
          </div>
          <div class="ml-2 my-3 p-2">
            <v-btn block color="primary" @click="editProject(canvas.id)"
              >编辑</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12" md="12">
      <p class="text-center text-h5">There is no canvas.</p>
    </v-col>
  </v-row>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
//例如: import <组件名称> from  <组建路径>
// import { mdiPoll } from "@mdi/js";
// import { getUserAvatar } from "@/service/wd_service_com.js";
// import KeyAvatarGroup from "@/components/customized/mv-key-avatar-group.vue";

// // Pubsub
// import { taskPubIds } from "@/service/wd_pubsub_config.js";
// import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    canvasList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // icons: {
      //   mdiPoll,
      // },
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    editProject(projectId) {
      window.location.href = `http://board.yipinapp.com?id=${projectId}`;
    },
    // getUserAvatar(portraitId) {
    //   return getUserAvatar(portraitId);
    // },
    // // Pubsub
    // pubCallback(msgName, data) {
    //   if (msgName == taskPubIds.pubId_Task_NewMessage) {
    //     this.getTaskUnreadCounts();
    //   }
    // },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    // subscribe(taskPubIds.pubId_Task_NewMessage, this.pubCallback);
  },
  destroyed() {
    // unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
